export default {
  props: {
    name: {
      type: String,
    },
    id: {
      type: String,
      require: true,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      require: true,
    },
    onEnter: {
      type: Function,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    focus() {
      document.getElementById(this.id).focus();
    },

    updateInput(value) {
      this.$emit('input', value);
    },
  },

  computed: {
    hasError() {
      return this.error !== null;
    },
  },
};
